import { Card, Row, Text, theme } from '@/components';
import { CloseOutlined } from '@ant-design/icons';
import type { FC, PropsWithChildren } from 'react';

type Props = {
  onRemove: () => void;
  title?: string;
  size?: 'default' | 'small';
  hideCloseButton?: boolean;
};

export const RemovableCard: FC<PropsWithChildren<Props>> = ({
  children,
  onRemove,
  title,
  size = 'default',
  hideCloseButton = false,
}) => {
  const { token } = theme.useToken();

  const closeBtn = (
    <CloseOutlined
      style={{ color: token.colorPrimary, padding: 8, margin: -8 }}
      onClick={() => {
        onRemove();
      }}
    />
  );

  return (
    <Card
      title={title && <Text variant="body" weight="medium" text={title} />}
      extra={title && !hideCloseButton && closeBtn}
      size={size}
    >
      {!title && !hideCloseButton && <Row justify="end">{closeBtn}</Row>}
      {children}
    </Card>
  );
};
